import { JudgeCasePresenter } from '@/presentation/presenters/testCase/judgeCasePresenter'
import { JudgeCaseViewModel } from '@/presentation/viewmodels/testCase/judgeCaseViewModel'

export function useJudgeCasePresenter(
  presenter: JudgeCasePresenter = new JudgeCasePresenter(new JudgeCaseViewModel())
) {
  return {
    judgeCaseList: presenter.judgeCaseList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    getJudgeCaseList: presenter.getJudgeCaseList.bind(presenter)
  }
}
